import * as React from 'react';
import { connect, Dispatch } from "react-redux";
import { AxiosError } from 'axios';

import {
    IApplicationState, IEmailFamilyState,
    EmailFamilyActionCreators, AppActionCreators, IEmailFamilyResponse, IEmailTypeResponse, IEmailExcelIdResponse
} from "@nkr/store/index";

import { IEmailFamily, IEmailType, IEmailExcelId, IEmailFamilyListResponse, IBaseResponse } from '@nkr/models/index';

import { Modal, Glyphicon, Alert, DropdownButton, MenuItem } from "react-bootstrap";
import { TableRowWrapper } from './styles';

interface IEmailFamilyOwnProps {
    emailFamilyId: number;
}

interface IEmailFamilyStateProps {
    emailFamilies: IEmailFamilyState;
}

interface IEmailFamilyDisptachProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getEmailFamilies: () => Promise<IEmailFamilyListResponse>,
    addEmailFamily: (emailFamilyName: string) => Promise<IEmailFamilyResponse>,
    deleteEmailFamily: (emailFamilyId: number) => Promise<IBaseResponse>,
    addEmailType: (emailTypeName: string, emailFamilyId: number) => Promise<IEmailTypeResponse>,
    deleteEmailType: (emailFamilyId: number, emailTypeId: number) => Promise<IBaseResponse>,
    addEmailExcelId: (emailExcelIdName: string, emailTypeId: number, emailFamilyId: number) => Promise<IEmailExcelIdResponse>
    deleteEmailExcelId: (emailFamilyId: number, emailTypeId: number, emailExcelId: number) => Promise<IBaseResponse>
}

type TEmailFamilyProps = IEmailFamilyStateProps & IEmailFamilyDisptachProps & IEmailFamilyOwnProps;

const enum confirmationModalType { None, EmailFamily, EmailType, EmailExcelId }

interface IState {
    selectedEmailFamilyId: number,
    selectedEmailTypeId: number,
    selectedEmailExcelId: number,
    addModal: {
        show: boolean,
        label: string,
        input: string,
        type: confirmationModalType
    },
    delete: {
        show: boolean,
        deleteType: string,
        type: string,
        emailFamilyId: number,
        emailTypeId: number,
        emailExcelId: number,
        name: string
    },
    message: {
        show: boolean,
        type: string,
        text: string
    },
    emailFamilyDetail: number[],
    emailTypeDetail: number[]
}

class EmailFamily extends React.Component<TEmailFamilyProps, IState>{
    constructor(props: TEmailFamilyProps) {
        super(props);

        this.state = {
            selectedEmailFamilyId: -1,
            selectedEmailTypeId: -1,
            selectedEmailExcelId: -1,
            addModal: {
                show: false,
                label: "",
                input: "",
                type: confirmationModalType.None
            },
            delete: {
                show: false,
                deleteType: "",
                type: "",
                emailFamilyId: 0,
                emailTypeId: 0,
                emailExcelId: 0,
                name: ""
            },
            message: {
                show: false,
                type: "",
                text: ""
            },
            emailFamilyDetail: [],
            emailTypeDetail: []
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        this.props.showLoading("Getting email families...").then(() => {
            this.props.getEmailFamilies()
                .then((response: IEmailFamilyListResponse) => {
                    this.props.hideLoading();

                    var emailFamilies: IEmailFamily[] = this.props.emailFamilies.list;

                    if (emailFamilies.length > 0) {
                        var emailFamily: IEmailFamily = emailFamilies[0];

                        if (emailFamily.emailTypes.length > 0) {
                            this.setState({
                                selectedEmailFamilyId: emailFamily.id,
                                selectedEmailTypeId: emailFamily.emailTypes[0].id,
                            });
                        }
                        else {
                            this.setState({
                                selectedEmailFamilyId: emailFamily.id,
                            });
                        }
                    }
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                })
        });
    }

    public showModal = (type: confirmationModalType) => {
        var label: string;

        switch (type) {
            case confirmationModalType.EmailFamily:
                label = "Email Family"
                break;
            case confirmationModalType.EmailType:
                label = "Email Type"
                break;
            case confirmationModalType.EmailExcelId:
                label = "Excel ID"
                break;
        }

        this.setState({
            addModal: {
                show: true,
                label,
                input: "",
                type
            }
        });
    }

    public addFamily = () => {
        this.showModal(confirmationModalType.EmailFamily);
    }

    public addType = (emailFamilyId: number) => {
        this.setState({
            selectedEmailFamilyId: emailFamilyId
        }, () => {
            this.showModal(confirmationModalType.EmailType)
        });
    }

    public addExcelId = (emailTypeId: number) => {
        this.setState({
            selectedEmailTypeId: emailTypeId
        }, () => {
            this.showModal(confirmationModalType.EmailExcelId);
        });
    }

    public delete = (deleteType: string, emailFamilyId: number, emailTypeId: number, emailExcelId: number) => {
        var emailFamily = this.props.emailFamilies.list.find(f => f.id == emailFamilyId);
        var emailType = emailFamily.emailTypes.find(t => t.id == emailTypeId);
        var emailExcel = (emailType != null ? emailType.emailExcelIds.find(e => e.id == emailExcelId) : null);

        switch (deleteType) {
            case "emailFamily":
                this.setState({
                    delete: {
                        show: true,
                        deleteType,
                        type: "email family",
                        emailFamilyId,
                        emailTypeId,
                        emailExcelId,
                        name: emailFamily.name
                    }
                });

                break;

            case "emailType":
                this.setState({
                    delete: {
                        show: true,
                        deleteType,
                        type: "email type",
                        emailFamilyId,
                        emailTypeId,
                        emailExcelId,
                        name: emailType.name
                    }
                });

                break;
            case "emailExcelId":
                this.setState({
                    delete: {
                        show: true,
                        deleteType,
                        type: "email Excel ID",
                        emailFamilyId,
                        emailTypeId,
                        emailExcelId,
                        name: emailExcel.name
                    }
                });

                break;
        }
    }

    public confirmationModalInputOnChange = (el) => {
        var value = el.target.value
        var addModal = { ...this.state.addModal, input: value };

        this.setState({
            addModal
        });
    }

    public confirmationModal_onClickOk = (el) => {
        var { type, input } = this.state.addModal;

        if (input.trim() == "") {
            return;
        }

        switch (type) {
            case confirmationModalType.EmailFamily:
                this.props.showLoading("Adding family, one moment please...").then(() => {
                    this.props.addEmailFamily(input)
                        .then((response) => {
                            var emailFamily: IEmailFamily = response.data.results;

                            this.setState({
                                selectedEmailFamilyId: emailFamily.id,
                                selectedEmailTypeId: -1,
                                selectedEmailExcelId: -1,
                                message: {
                                    show: true,
                                    type: "success",
                                    text: "Email family added successfully..."
                                }
                            }, () => {
                                this.props.hideLoading();
                            });
                        })
                        .catch((error: AxiosError) => {
                            this.props.hideLoading();

                            this.setState({
                                message: {
                                    show: true,
                                    type: "danger",
                                    text: error.message
                                }
                            })
                        });
                });

                break;

            case confirmationModalType.EmailType:
                this.props.showLoading("Adding email type to family, one moment please...").then(() => {
                    this.props.addEmailType(input, this.state.selectedEmailFamilyId)
                        .then((response) => {
                            var emailType: IEmailType = response.data.results;

                            this.setState({
                                selectedEmailTypeId: emailType.id,
                                message: {
                                    show: true,
                                    type: "success",
                                    text: "Email type added to family successfully..."
                                }
                            }, () => {
                                this.props.hideLoading();
                            });
                        })
                        .catch((error: AxiosError) => {
                            this.props.hideLoading();

                            this.setState({
                                message: {
                                    show: true,
                                    type: "danger",
                                    text: error.message
                                }
                            })
                        });
                });

                break;

            case confirmationModalType.EmailExcelId:
                this.props.showLoading("Adding excel ID to family/type, one moment please...").then(() => {
                    this.props.addEmailExcelId(input, this.state.selectedEmailTypeId, this.state.selectedEmailFamilyId)
                        .then((response) => {
                            this.props.hideLoading();
                            this.setState({
                                message: {
                                    show: true,
                                    type: "success",
                                    text: "Excel ID added to type successfully..."
                                }
                            })
                        })
                        .catch((error: AxiosError) => {
                            this.props.hideLoading();

                            this.setState({
                                message: {
                                    show: true,
                                    type: "danger",
                                    text: error.message
                                }
                            })
                        });
                });

                break;
        }

        this.setState({
            addModal: { ...this.state.addModal, show: false }
        });
    }

    public confirmationModal_onHide = () => {
        var addModal = { ...this.state.addModal, show: false }

        this.setState({
            addModal
        });
    }

    public deleteModal_onClickOk = () => {
        var d = { ...this.state.delete, show: false };

        switch (d.deleteType) {
            case "emailFamily":
                this.props.showLoading("Deleting email family, one moment please...").then(() => {
                    this.props.deleteEmailFamily(d.emailFamilyId)
                        .then((response: IBaseResponse) => {
                            if (response.data.success) {
                                let selectedEmailFamily = this.props.emailFamilies.list.length > 0 ? this.props.emailFamilies.list[0] : null;
                                let selectedEmailType: IEmailType = selectedEmailFamily != null && selectedEmailFamily.emailTypes.length > 0 ? selectedEmailFamily.emailTypes[0] : null;
                                let selectedEmailExcelId: IEmailExcelId = selectedEmailType != null && selectedEmailType.emailExcelIds.length > 0 ? selectedEmailType.emailExcelIds[0] : null;

                                this.setState({
                                    delete: d,
                                    selectedEmailFamilyId: selectedEmailFamily != null ? selectedEmailFamily.id : -1,
                                    selectedEmailTypeId: selectedEmailType != null ? selectedEmailType.id : -1,
                                    selectedEmailExcelId: selectedEmailExcelId != null ? selectedEmailExcelId.id : -1,
                                    message: {
                                        show: true,
                                        type: "success",
                                        text: "Email family deleted successfully..."
                                    }
                                }, () => {

                                    this.props.hideLoading();
                                });
                            } else {
                                this.setState({
                                    delete: d,
                                    message: {
                                        show: true,
                                        type: "danger",
                                        text: "Unable to delete email family, it is currently in use..."
                                    }
                                }, () => {
                                    this.props.hideLoading();
                                });
                            }
                        })
                        .catch((error: AxiosError) => {
                            this.setState({
                                delete: d,
                                message: {
                                    show: true,
                                    type: "danger",
                                    text: error.message
                                }
                            }, () => {
                                this.props.hideLoading();
                            });
                        });
                });

                break;

            case "emailType":
                this.props.showLoading("Deleting email type, one moment please...").then(() => {
                    this.props.deleteEmailType(d.emailFamilyId, d.emailTypeId)
                        .then((response: IBaseResponse) => {
                            if (response.data.success) {
                                let selectedEmailFamily = this.props.emailFamilies.list.find(f => f.id == d.emailFamilyId);
                                let selectedEmailType: IEmailType = selectedEmailFamily.emailTypes.length > 0 ? selectedEmailFamily.emailTypes[0] : null;
                                let selectedEmailExcelId: IEmailExcelId = selectedEmailType != null && selectedEmailType.emailExcelIds.length > 0 ? selectedEmailType.emailExcelIds[0] : null;

                                this.setState({
                                    delete: d,
                                    selectedEmailFamilyId: selectedEmailFamily != null ? selectedEmailFamily.id : -1,
                                    selectedEmailTypeId: selectedEmailType != null ? selectedEmailType.id : -1,
                                    selectedEmailExcelId: selectedEmailExcelId != null ? selectedEmailExcelId.id : -1,
                                    message: {
                                        show: true,
                                        type: "success",
                                        text: "Email type deleted successfully..."
                                    }
                                }, () => {
                                    this.props.hideLoading();
                                });
                            } else {
                                this.setState({
                                    delete: d,
                                    message: {
                                        show: true,
                                        type: "danger",
                                        text: "Unable to delete email type, it is currently in use..."
                                    }
                                }, () => {
                                    this.props.hideLoading();
                                });
                            }
                        })
                        .catch((error: AxiosError) => {
                            this.setState({
                                delete: d,
                                message: {
                                    show: true,
                                    type: "danger",
                                    text: error.message
                                }
                            }, () => {
                                this.props.hideLoading();
                            });
                        });
                });

                break;

            case "emailExcelId":
                this.props.showLoading("Deleting email excel ID, one moment please...").then(() => {
                    this.props.deleteEmailExcelId(d.emailFamilyId, d.emailTypeId, d.emailExcelId)
                        .then((response: IBaseResponse) => {
                            if (response.data.success) {
                                let selectedEmailFamily = this.props.emailFamilies.list.find(f => f.id == d.emailFamilyId);
                                let selectedEmailType = selectedEmailFamily.emailTypes.find(t => t.id == d.emailTypeId);
                                let selectedEmailExcelId: IEmailExcelId = selectedEmailType.emailExcelIds.length > 0 ? selectedEmailType.emailExcelIds[0] : null;

                                this.setState({
                                    delete: d,
                                    selectedEmailFamilyId: selectedEmailFamily != null ? selectedEmailFamily.id : -1,
                                    selectedEmailTypeId: selectedEmailType != null ? selectedEmailType.id : -1,
                                    selectedEmailExcelId: selectedEmailExcelId != null ? selectedEmailExcelId.id : -1,
                                    message: {
                                        show: true,
                                        type: "success",
                                        text: "Email excel ID deleted successfully..."
                                    }
                                }, () => {
                                    this.props.hideLoading();
                                });
                            } else {
                                this.setState({
                                    delete: d,
                                    message: {
                                        show: true,
                                        type: "danger",
                                        text: "Unable to delete email excel ID, it is currently in use..."
                                    }
                                }, () => {
                                    this.props.hideLoading();
                                });
                            }
                        })
                        .catch((error: AxiosError) => {
                            this.setState({
                                delete: d,
                                message: {
                                    show: true,
                                    type: "danger",
                                    text: error.message
                                }
                            }, () => {
                                this.props.hideLoading();
                            });
                        });
                });

                break;
        }
    }

    public deleteModal_onHide = () => {
        let d = { ...this.state.delete, show: false };

        this.setState({
            delete: d
        });
    }

    public showEmailFamilyDetail = (emailFamilyId) => {
        let emailFamilyDetail = [...this.state.emailFamilyDetail];

        if (emailFamilyDetail.indexOf(emailFamilyId) >= 0)
            emailFamilyDetail = emailFamilyDetail.filter(f => f != emailFamilyId);
        else
            emailFamilyDetail.push(emailFamilyId);

        this.setState({
            emailFamilyDetail
        });
    }

    public showEmailTypeDetail = (emalTypeId) => {
        let emailTypeDetail = [...this.state.emailTypeDetail];

        if (emailTypeDetail.indexOf(emalTypeId) >= 0)
            emailTypeDetail = emailTypeDetail.filter(f => f != emalTypeId);
        else
            emailTypeDetail.push(emalTypeId);

        this.setState({
            emailTypeDetail
        });
    }

    public expandAll = () => {
        let emailFamilyDetail = [];
        let emailTypeDetail = [];

        this.props.emailFamilies.list.forEach(f => {
            emailFamilyDetail.push(f.id);
            f.emailTypes.forEach(t => {
                emailTypeDetail.push(t.id);
            })
        });

        this.setState({
            emailFamilyDetail,
            emailTypeDetail
        });
    }

    public collapseAll = () => {
        let emailFamilyDetail = [];
        let emailTypeDetail = [];

        this.setState({
            emailFamilyDetail,
            emailTypeDetail
        });
    }

    public dismissMessage = () => {
        this.setState({
            message: { ...this.state.message, show: false }
        });
    }

    public renderFamilyRow = (emailFamily: IEmailFamily, index: number) => {
        let showTypes = this.state.emailFamilyDetail.indexOf(emailFamily.id) >= 0;
        let glyph = showTypes ? "chevron-down" : "chevron-right";
        let backgroundColor = index % 2 == 0 ? "#ddd" : "#fff";

        return (
            <>
                <TableRowWrapper key={index}>
                    <td>
                        <Glyphicon glyph={glyph} onClick={() => this.showEmailFamilyDetail(emailFamily.id)} />
                        <a style={{ marginLeft: 5, marginRight: 5, cursor: "pointer" }} onClick={() => this.showEmailFamilyDetail(emailFamily.id)}>{emailFamily.name}</a>
                    </td>
                    <td></td>
                    <td></td>
                    <td style={{ textAlign: "right" }}>
                        <DropdownButton
                            bsStyle={"link"}
                            bsSize="small"
                            title={<Glyphicon glyph="cog" />}
                            key={index}
                            id={`dropdown-basic-${index}`}
                            noCaret
                            style={{ fontSize: 16 }}
                        >
                            <MenuItem eventKey="1" onClick={() => this.addType(emailFamily.id)}>Add Type</MenuItem>
                            <MenuItem eventKey="2" onClick={() => this.delete('emailFamily', emailFamily.id, -1, -1)}>Delete</MenuItem>
                        </DropdownButton>
                    </td>
                </TableRowWrapper>

                {emailFamily.emailTypes.map((type, emailTypeIndex) =>
                    this.renderEmailTypeRow(type, emailFamily.id, emailTypeIndex, backgroundColor)
                )}
            </>
        );
    }

    public renderEmailTypeRow = (emailType: IEmailType, emailFamilyId: number, index: number, bgColor: string) => {
        let showExcelIds = this.state.emailTypeDetail.indexOf(emailType.id) >= 0;
        let glyph = showExcelIds ? "chevron-down" : "chevron-right";
        let marginLeft = emailType.emailExcelIds.length > 0 ? 5 : 20;

        if (this.state.emailFamilyDetail.indexOf(emailFamilyId) >= 0)
            return (
                <>
                    <TableRowWrapper>
                        <td></td>
                        <td>
                            {emailType.emailExcelIds.length > 0 ?
                                <Glyphicon glyph={glyph} onClick={() => this.showEmailTypeDetail(emailType.id)} />
                                : null}
                            <a style={{ marginLeft, marginRight: 5, cursor: "pointer" }} onClick={() => this.showEmailTypeDetail(emailType.id)}>{emailType.name}</a>
                        </td>
                        <td></td>
                        <td style={{ textAlign: "right" }}>
                            <DropdownButton
                                bsStyle={"link"}
                                bsSize="small"
                                title={<Glyphicon glyph="cog" />}
                                key={index}
                                id={`dropdown-basic-${index}`}
                                noCaret
                                style={{ fontSize: 16 }}
                            >
                                <MenuItem eventKey="1" onClick={() => this.addExcelId(emailType.id)}>Add Excel ID</MenuItem>
                                <MenuItem eventKey="2" onClick={() => this.delete('emailType', emailFamilyId, emailType.id, -1)}>Delete</MenuItem>
                            </DropdownButton>
                        </td>
                    </TableRowWrapper>

                    {emailType.emailExcelIds.map((excelId, emailExcelIdIndex) =>
                        this.renderEmailExcelIdRow(emailFamilyId, emailType.id, excelId, emailExcelIdIndex)
                    )}
                </>
            );
        else
            return null;
    }

    public renderEmailExcelIdRow = (emailFamilyId: number, emailTypeId: number, excelId: IEmailExcelId, index: number) => {
        if (this.state.emailTypeDetail.indexOf(emailTypeId) >= 0)
            return (
                <TableRowWrapper>
                    <td></td>
                    <td></td>
                    <td>
                        <span style={{ marginRight: 5 }}>{excelId.name}</span>
                    </td>
                    <td style={{ textAlign: "right" }}>
                        <DropdownButton
                            bsStyle={"link"}
                            bsSize="small"
                            title={<Glyphicon glyph="cog" />}
                            key={index}
                            id={`dropdown-basic-${index}`}
                            noCaret
                            style={{ fontSize: 16 }}
                        >
                            {/* <MenuItem eventKey="1" onClick={() => this.addExcelId(emailType.id)}>Add Excel ID</MenuItem> */}
                            <MenuItem eventKey="2" onClick={() => this.delete('emailExcelId', emailFamilyId, emailTypeId, excelId.id)}>Delete</MenuItem>
                        </DropdownButton>
                    </td>
                </TableRowWrapper>
            );
        else
            return null;
    }

    public render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-xs-12">
                        <h2 style={{ marginTop: 0, marginBottom: 20 }}>Email Tags</h2>
                    </div>
                </div>

                {this.state.message.show ?
                    <Alert bsStyle={this.state.message.type} onDismiss={this.dismissMessage}>
                        {this.state.message.text}
                    </Alert>
                    : null}

                <div className="row">
                    <div className="col-xs-12" style={{ display: "flex", justifyContent: "flex-end", marginBottom: 5 }}>
                        <button className="btn btn-primary" style={{ marginRight: 5 }} onClick={this.addFamily}>Add Family</button>
                        <button type="button" className="btn btn-default" style={{ marginRight: 5 }} onClick={this.expandAll}>Expand All</button>
                        <button type="button" className="btn btn-default" onClick={this.collapseAll}>Collapse All</button>
                    </div>
                </div>

                <table className="table table-condensed table-striped">
                    <thead>
                        <tr>
                            <th style={{ width: "25%" }}>Family</th>
                            <th style={{ width: "25%" }}>Type</th>
                            <th style={{ width: "25%" }}>Excel ID</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.emailFamilies.list.map((family, index) =>
                            this.renderFamilyRow(family, index)
                        )}
                    </tbody>
                </table>


                <Modal show={this.state.addModal.show} onHide={() => null}>
                    <Modal.Header>
                        <Modal.Title>Add {this.state.addModal.label}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <label className="control-label" htmlFor="addInput">{this.state.addModal.label}...</label>
                        <input type="text" className="form-control" id="addInput" onChange={this.confirmationModalInputOnChange}></input>
                    </Modal.Body>
                    <Modal.Footer >
                        <button className="btn btn-primary" onClick={this.confirmationModal_onClickOk}>Ok</button>
                        <button className="btn btn-danger" onClick={this.confirmationModal_onHide}>Cancel</button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.delete.show} onHide={() => null}>
                    <Modal.Header>
                        <Modal.Title>Confirm Delete?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>Are you sure you want to delete the following <b>{this.state.delete.type}</b>?</div>
                        <div style={{ marginTop: 20, marginLeft: 20 }}>{this.state.delete.name}</div>
                    </Modal.Body>
                    <Modal.Footer >
                        <button className="btn btn-primary" onClick={this.deleteModal_onClickOk}>Ok</button>
                        <button className="btn btn-danger" onClick={this.deleteModal_onHide}>Cancel</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState, ownProps: IEmailFamilyOwnProps): IEmailFamilyStateProps => {
    return {
        emailFamilies: state.emailFamilies
    }
}

const mapDisptachToProps = (dispatch: Dispatch<any>): IEmailFamilyDisptachProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getEmailFamilies: () => { return dispatch(EmailFamilyActionCreators.getEmailFamily()); },
        addEmailFamily: (emailFamilyName) => { return dispatch(EmailFamilyActionCreators.addEmailFamily(emailFamilyName)); },
        deleteEmailFamily: (emailFamilyId) => { return dispatch(EmailFamilyActionCreators.deleteEmailFamily(emailFamilyId)); },
        addEmailType: (emailTypeName, emailFamilyId) => { return dispatch(EmailFamilyActionCreators.addEmailType(emailTypeName, emailFamilyId)) },
        deleteEmailType: (emailFamilyId, emailTypeId) => { return dispatch(EmailFamilyActionCreators.deleteEmailType(emailFamilyId, emailTypeId)); },
        addEmailExcelId: (emailExcelIdName, emailTypeId, emailFamilyId) => { return dispatch(EmailFamilyActionCreators.addEmailExcelId(emailExcelIdName, emailTypeId, emailFamilyId)) },
        deleteEmailExcelId: (emailFamilyId, emailTypeId, emailExcelId) => { return dispatch(EmailFamilyActionCreators.deleteEmailExcelId(emailFamilyId, emailTypeId, emailExcelId)); }
    };
}

export default connect<IEmailFamilyStateProps, IEmailFamilyDisptachProps, IEmailFamilyOwnProps>(
    mapStateToProps,
    mapDisptachToProps)(EmailFamily);

